(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-official-rules"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('ai-official-rules');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const body = document.body;
    const root = document.documentElement;
    const content = dialog.querySelector('.ai-rules__body');
    const targetPath = new URL(dialog.dataset.rulesUrl, location.origin).pathname.replace(/\/$/, '');
    let trigger;
    let saved;
    let enterRequested = false;
    const isRulesLink = (link) => {
      if (!link || dialog.contains(link)) return false;
      const url = new URL(link.href, location.href);
      return url.origin === location.origin && url.pathname.replace(/\/$/, '') === targetPath && !url.hash;
    };
    document.querySelectorAll('a[href]').forEach((link) => {
      if (isRulesLink(link)) {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', dialog.id);
      }
    });
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!isRulesLink(link) || link.hasAttribute('download') || dialog.open) return;
      event.preventDefault();
      event.stopPropagation();
      trigger = link;
      saved = { x: window.scrollX, y: window.scrollY, body: body.getAttribute('style'), overflow: root.style.overflow };
      dialog.showModal();
      root.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = '-' + saved.y + 'px';
      body.style.left = '-' + saved.x + 'px';
      body.style.width = '100%';
      content.scrollTop = 0;
      dialog.querySelector('#ai-rules-title').focus({ preventScroll: true });
    }, true);
    dialog.querySelectorAll('[data-rules-close]').forEach((button) => {
      button.addEventListener('click', () => dialog.close());
    });
    dialog.querySelector('[data-rules-enter]').addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!document.getElementById('ais7-entry')) return;
      event.preventDefault();
      enterRequested = true;
      dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!saved) return;
      if (saved.body === null) body.removeAttribute('style');
      else body.setAttribute('style', saved.body);
      root.style.overflow = saved.overflow;
      window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      saved = null;
      if (enterRequested) {
        enterRequested = false;
        const entry = document.getElementById('ais7-entry');
        entry.scrollIntoView({ behavior: 'instant', block: 'start' });
        entry.querySelector('[data-tier-button]')?.focus({ preventScroll: true });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
